if (!customElements.get('product-group')) {
  class ProductGroup extends HTMLElement {
    constructor() {
      super();
      // get the select from the element.
      this.select = this.querySelector('select');
      // listen for changes to the select and pass the event.
      this.select.addEventListener('change', this.onProductChange.bind(this));
    }

    onProductChange() {
      // get url from data-url attribute.
      this.url = this.select.options[this.select.selectedIndex].dataset.url;
      // redirect to the new url.
      window.location.href = this.url;
    }
  }

  window.ProductGroup = ProductGroup;
  customElements.define('product-group', ProductGroup);
}
